<template>
  <draggable
    v-bind="dragOptions"
    tag="div"
    class="item-container"
    :list="list"
    :value="value"
    @input="emitter"
    @end="onEndTaskDrop"
  >
    <div class="item-group" :key="task._id" v-for="task in realValue">
      <Task :task="task" :done="task.done" />
      <!-- @change_complete="change_complete"
        @delete_task="delete_task" -->
      <NestedTasks class="item-sub" :list="task.elements" />
    </div>
  </draggable>
</template>

<script>
import draggable from "vuedraggable";
import Task from "./Task";
export default {
  name: "NestedTasks",
  methods: {
    emitter(value) {
      console.log("emitter", value, this.realValue);
    },
    onEndTaskDrop(newIndex) {
      console.log(newIndex);
    },
  },
  components: {
    draggable,
    Task,
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
    // this.value when input = v-model
    // this.list  when input != v-model
    realValue() {
      return this.value ? this.value : this.list;
    },
  },
  props: {
    value: {
      required: false,
      type: Array,
      default: null,
    },
    list: {
      required: false,
      type: Array,
      default: null,
    },
  },
};
</script>

<style scoped>
.item-container {
  max-width: 20rem;
  margin: 0;
}
.item {
  padding: 1rem;
  border: solid black 1px;
  background-color: #fefefe;
}
.item-sub {
  margin: 0 0 0 1rem;
}
</style>
